import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  InputBase,
  List,
  ListItemText,
  Paper,
} from "@mui/material";
import Swal from "sweetalert2";

import { useMaterialUIController } from "context";
import { getMenu } from "controllers/MenuController";
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import getText from "Translator";
import { copyFilesToNewClinic } from "controllers/FileController";

const ClinicsComponent = (props) => {
  const [clinics, setClinics] = useState();
  
  const [expanded, setExpanded] = useState("panel1");
  const [search, setSearch] = useState("");
  const [controller, dispatch] = useMaterialUIController();
  const { handleClose, selectedFiles} = props;
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const getData = async () => {
    let menu = await localStorage.getItem("$menu");
    menu = JSON.parse(menu);
    let newData = {
      headline: menu.headline,
    };
    let res = await getMenu(newData, controller);
    if (res.success) {
      setClinics(res.data);
      console.log("setClinics", res.data);
    } else {
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      {clinics?.map((item) => (
        <Accordion
          square
          expanded={expanded === "panel" + item.title}
          onChange={handleChange("panel" + item.title)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id={"panel" + item.title}
          >
            <div style={{ fontSize: 14 }}>{item.titleText}</div>
          </AccordionSummary>
          <AccordionDetails>
            <List id="mainlistx" key="mainlistx">
              {item.capsules &&
                item.capsules.map((itemc, index) => (
                  <ListItemText
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      paddingTop: 7,
                      paddingBottom: 7,
                    }}
                    className="list"
                    key={"btnc" + index}
                    button
                    onClick={() => {
                      let alt =
                        "Do you want to send the file(s) to " +
                        itemc.capsuleText +
                        " ?";
                      if ("fa" == "fa") {
                        alt =
                          " آیا مایل به ارسال فایل(ها) به کلینیک  " +
                          itemc.capsuleText +
                          "   هستید؟";
                      }
                      Swal.fire({
                        title: getText("warning", "fa"),
                        text: alt,
                        cancelButtonText: getText("no", "fa"),
                        confirmButtonText: getText("yes", "fa"),
                        showCancelButton: true,
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                          handleClose();
                          let newData = {
                            capsule: itemc.capsule,
                            title: item.title,
                            files: selectedFiles,
                          };
                          let result = await copyFilesToNewClinic(
                            newData,
                            controller
                          );
                          if (result.success) {
                            Swal.fire({
                              title: "",
                              icon: "success",
                              text: getText("alertsuccess", "fa"),
                              confirmButtonText: getText("ok", "fa"),
                            });
                          }
                        }
                      });
                    }}
                  >
                    {itemc.capsuleText}
                  </ListItemText>
                ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};
export default ClinicsComponent;
